// wed-assets private bucket helpers. Markdown keeps the stable reference URL
// (https://storage.googleapis.com/<bucket>/<key>); the bucket is private, so
// rendering swaps it for a short-lived signed URL via GET /assets/sign-urls.
// Single source for the bucket name — override with VITE_GCS_BUCKET if needed.
const ASSETS_BUCKET =
  (import.meta.env.VITE_GCS_BUCKET as string | undefined) || "wed-assets";

export const ASSETS_URL_PREFIX = `https://storage.googleapis.com/${ASSETS_BUCKET}/`;

/** Whether a markdown img src points into the private assets bucket */
export const isAssetUrl = (src?: string): src is string =>
  !!src && src.startsWith(ASSETS_URL_PREFIX);

/**
 * HTML attachment in the assets bucket (AI-generated reports / prototypes).
 * The server forces a `.html` key for text/html uploads; such links render
 * through a cross-origin sandboxed iframe instead of a plain anchor.
 */
export const isHtmlAssetUrl = (href?: string): href is string =>
  isAssetUrl(href) && /\.html$/i.test(href.split(/[?#]/)[0]);

/** Whether a dropped/pasted file is an HTML document (by type or extension) */
export const isHtmlFile = (f: File) =>
  f.type === "text/html" || /\.html?$/i.test(f.name);

export interface SignAssetResult {
  ref: string;
  url?: string;
  error?: string;
}

export interface SignAssetsResponse {
  results: SignAssetResult[];
}
